export default __webpack_public_path__ + "static/media/eco.e144f8c9.png";